import api from "../services/api";

// Fetch packages function with credentials
export const fetchPackages = async (filterField, filterValue, page = 1, size = 50) => {
  try {
    const params = { page, size };
    if (filterField && filterValue) {
      params.filter_field = filterField;
      params.filter_value = filterValue;
    }

    // Make the API request with credentials
    const response = await api.get("/package-management/packages", {
      params,
    });
    if (response.status === 200) {
      return response.data.data;
    } else {
      console.warn("Unexpected Response:", response);
      return { error: "Unexpected response from server" };
    }
  } catch (error) {
    console.error("Error fetching packages:", error.message || error);
    const errorMessage = error.response?.data?.detail || error.message || "Failed to fetch packages";
    return { error: errorMessage };
  }
};

// Add Size Estimate function
export const addSizeEstimate = async (newSizeEstimate) => {
  try {
    // Make the API request to add a new size estimate
    const response = await api.post("/package-management/size-estimates", newSizeEstimate);

    if (response.status === 200) {
      // Return the data if the request is successful
      return response.data.data;
    } else {
      console.warn("Unexpected Response:", response);
      return { error: "Unexpected response from server" };
    }
  } catch (error) {
    console.error("Error adding size estimate:", error.message || error);
    const errorMessage = error.response?.data?.detail || error.message || "Failed to add size estimate";
    return { error: errorMessage };
  }
};

// Fetch size estimates by category (e.g., 'Small', 'Medium', 'Large', 'Extra Large')
export const fetchSizeEstimate = async (sizeCategory) => {
  try {
    // Make the API request with the sizeCategory parameter
    const response = await api.get(`/package-management/size-estimates/${sizeCategory}`);

    if (response.status === 200) {
      // Return the data if the request is successful
      return response.data.data;
    } else {
      console.warn("Unexpected Response:", response);
      return { error: "Unexpected response from server" };
    }
  } catch (error) {
    console.error("Error fetching size estimates:", error.message || error);
    const errorMessage = error.response?.data?.detail || error.message || "Failed to fetch size estimates";
    return { error: errorMessage };
  }
};


// Fetch all size estimates (no filtering by category)
export const fetchAllSizeEstimates = async () => {
  try {
    const response = await api.get("/package-management/size-estimates");

    if (response.status === 200) {
      return response.data.data;
    } else {
      console.warn("Unexpected response:", response);
      return { error: "Unexpected response from server" };
    }
  } catch (error) {
    console.error("Error fetching all size estimates:", error.message || error);
    const errorMessage = error.response?.data?.detail || error.message || "Failed to fetch size estimates";
    return { error: errorMessage };
  }
};

// Update a size estimate by category (e.g., "Small", "Medium", "Large")
export const updateSizeEstimate = async (sizeCategory, payload) => {
  try {
    const response = await api.put(`/package-management/size-estimates/${sizeCategory}`, payload);

    if (response.status === 200) {
      return response.data;
    } else {
      console.warn("Unexpected response:", response);
      return { error: "Unexpected response from server" };
    }
  } catch (error) {
    console.error(`Error updating size estimate for ${sizeCategory}:`, error.message || error);
    const errorMessage =
      error.response?.data?.detail || error.message || "Failed to update size estimate";
    return { error: errorMessage };
  }
};
